// --- Helper Functions ---
const timeAgo = (date) => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    let interval = seconds / 31536000;
    if (interval > 1) return Math.floor(interval) + " বছর আগে";
    interval = seconds / 2592000;
    if (interval > 1) return Math.floor(interval) + " মাস আগে";
    interval = seconds / 86400;
    if (interval > 1) return Math.floor(interval) + " দিন আগে";
    interval = seconds / 3600;
    if (interval > 1) return Math.floor(interval) + " ঘন্টা আগে";
    interval = seconds / 60;
    if (interval > 1) return Math.floor(interval) + " মিনিট আগে";
    return Math.floor(seconds) + " সেকেন্ড আগে";
};
export { timeAgo };